import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

// Custom matcher to force error state if your custom 'errors' property exists
export class ApiErrorStateMatcher implements ErrorStateMatcher {
  constructor(private getApiError: () => boolean) {}

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched)) || this.getApiError();
  }
}
